import { combineReducers } from 'redux'

// ACTIONS
export const CREATE = 'offerzen/blockedCompanies/CREATE'
export const CREATE_SUCCESS = 'offerzen/blockedCompanies/CREATE_SUCCESS'

export const FETCH = 'offerzen/blockedCompanies/FETCH'
export const FETCH_SUCCESS = 'offerzen/blockedCompanies/FETCH_SUCCESS'

export const DELETE = 'offerzen/blockedCompanies/DELETE'
export const LINKED_COMPANY = 'offerzen/blockedCompanies/LINKED_COMPANY'

export const TOGGLE_CONFIRMATION_DIALOG = 'offerzen/blockedCompanies/TOGGLE_CONFIRMATION_DIALOG'

export const THROW_ERROR = 'offerzen/blockedCompanies/THROW_ERROR'
export const CLEAR_ERROR = 'offerzen/blockedCompanies/CLEAR_ERROR'

export const SHOW_MESSAGE = 'offerzen/blockedCompanies/SHOW_MESSAGE'
export const CLEAR_MESSAGE = 'offerzen/blockedCompanies/CLEAR_MESSAGE'

export const SEARCH_COMPANIES = 'offerzen/blockedCompanies/SEARCH_COMPANIES'
export const SEARCH_COMPANIES_SUCCESS = 'offerzen/blockedCompanies/SEARCH_COMPANIES_SUCCESS'
export const SEARCH_COMPANIES_ERROR = 'offerzen/blockedCompanies/SEARCH_COMPANIES_ERROR'

// CREATE CREATORS
export const createBlockedCompany = (id, data) => ({
  type: CREATE,
  payload: { id, data },
})

export const addLinkedCompanies = data => ({
  type: LINKED_COMPANY,
  payload: { ...data },
})

export const fetchBlockedCompanies = id => ({
  type: FETCH,
  payload: { id },
})

export const fetchBlockedCompaniesSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const deleteBlockedCompany = (id, candidate_id) => ({
  type: DELETE,
  payload: { id, candidate_id },
})

export const toggleConfirmationDialog = dialog => ({
  type: TOGGLE_CONFIRMATION_DIALOG,
  payload: { dialog },
})

export const throwError = error => ({
  type: THROW_ERROR,
  payload: { error },
})

export const clearError = () => ({
  type: CLEAR_ERROR,
  payload: { error: '' },
})

export const showMessage = message => ({
  type: SHOW_MESSAGE,
  payload: { message },
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
  payload: { message: '' },
})

export const searchCompanies = term => ({
  type: SEARCH_COMPANIES,
  meta: { term },
  payload: {
    searching: true,
  },
})

export const searchCompaniesSuccess = data => ({
  type: SEARCH_COMPANIES_SUCCESS,
  payload: {
    searching: false,
    data,
  },
})

export const searchCompaniesError = errorMessage => ({
  type: SEARCH_COMPANIES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

// REDUCERS
const blockedCompany = (state = {}, action) => {
  switch (action.type) {
    case CREATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

const linkedCompanies = (state = {}, action) => {
  switch (action.type) {
    case LINKED_COMPANY:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

const entities = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      const nextState = { ...state }
      action.payload.forEach(company => (nextState[company.id] = company))
      return nextState

    case CREATE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: blockedCompany(state[action.payload.id], action),
      }

    default:
      return state
  }
}

const byId = (state = [], action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      return action.payload.map(company => company.id)

    case CREATE_SUCCESS:
      return [...state, action.payload.id]

    default:
      return state
  }
}

const confirmationDialog = (state = {}, action) => {
  switch (action.type) {
    case TOGGLE_CONFIRMATION_DIALOG:
      return {
        ...state,
        ...action.payload.dialog,
      }

    default:
      return state
  }
}

const notices = (
  state = {
    error: '',
    message: '',
  },
  { payload, type },
) => {
  switch (type) {
    case THROW_ERROR:
    case CLEAR_ERROR:
    case SHOW_MESSAGE:
    case CLEAR_MESSAGE:
      return {
        ...state,
        ...payload,
      }

    default:
      return state
  }
}

const defaultSearch = {
  searching: false,
  results: [],
  error: null,
}

const search = (state = defaultSearch, { type, payload }) => {
  switch (type) {
    case SEARCH_COMPANIES:
      return {
        ...state,
        searching: payload.searching,
      }

    case SEARCH_COMPANIES_SUCCESS:
      return {
        ...state,
        searching: payload.searching,
        results: payload.data,
      }

    case SEARCH_COMPANIES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }

    default:
      return state
  }
}

const blockedCompaniesReducer = combineReducers({
  entities,
  ids: byId,
  linkedCompanies,
  confirmationDialog,
  notices,
  search,
})

export default blockedCompaniesReducer
